import React from 'react';
import classNames from 'classnames';

import './CtaButton.css';

function CtaButton({
  children,
  type = 'primary',
  size = 'md',
  fullWidth = false,
  fullWidthMobile = false,
  className,
  onClick,
  ...props
}) {
  return (
    <button
      className={classNames(
        'cta-button-component',
        `cta-button-component-${type}`,
        `cta-button-component-${size}`,
        fullWidth && `cta-button-component-full-width`,
        fullWidthMobile && 'cta-button-component-full-width-mobile',
        className
      )}
      data-event-category="button"
      data-on="click"
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
}

export default CtaButton;



// WEBPACK FOOTER //
// ./src/components/elements/CtaButton/index.js